<template>
  <div
    class="roster-time-input-frame"
    :title="helpText"
  >
    <CInput class="preika-control-frame--time"
      type="time"
      maxlength="5"
      style="margin-bottom: 3px"
      :value="displayValue"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="onInput"
      :tabindex="tabindex"
      @focus="onFocus"
      @blur="onBlur"
    />
    <!--
      **場所は常に取る。**この欄だけ注記が出ないと、同じ行の他の欄
      （開始時刻・終了時刻・夜勤休憩は候補を1行出す）より背が低くなり、
      入力欄の縦位置がずれる。テスターの指摘はこれ（2026-09-09）。
    -->
    <!--
      文は、勤務表がその行の休憩を固定しているか（manual）だけで出し分ける。
      この部品が「この画面で入力したか」を自分で覚えると、保存して開き直した行や、
      時刻を消して固定が外れた行で、文と実際の動きが食い違う。

      時刻を持たない区分（休日・有給・代休・欠勤・特休有給）で、開始も終了も無い行（blankDay）には出さない。
      時刻が無い行では休憩の自動計算が走らないので、「自動反映」は事実と合わない。休憩だけが残った古い休暇の行
      （時刻なし・休憩あり）も同じ。休憩で出し分けると、その行は開き直すたびに「自動反映」と出る（固定の印は
      開始がある行にしか付かない）。休日に出勤した行（休日＋時刻）と平日の行には、今までどおり出す。
      flg そのものは変えない（マウスを乗せたときの説明 helpText も flg を見ているため）。
    -->
    <!--
      注記は1行に固定する（折り返さない・高さ 16px）。2行になると、この欄だけ背が伸び、セルの縦の中央揃えで
      入力欄が他の列より上へずれる（監査 FF-1。12px の「定時後休憩を自動反映」は 120px で、欄の幅 112px に
      入らなかった）。欄の幅は他の時刻の欄と同じ 112px のまま（scripts/check-compact-control-layout.js）にして、
      はみ出す 8px はセルの右の余白（13px）に出す（切らない・隣の列には届かない）。
    -->
    <small class="roster-auto-rest-note">
      <template v-if="flg && !disabled && !blankDay"
        >{{ manual ? '実績へ手動修正済み' : '定時後休憩を自動反映' }}</template>
    </small>
  </div>
</template>

<script>
export default {
  name: "RestInput",
  props: {
    rest: String,
    index: Number,
    postBuffer: String,
    breakBasic: String,
    flg: Boolean,
    // 時刻を持たない区分で、開始も終了も無い行か（欄の下の文を出さない）。
    blankDay: Boolean,
    actualEnd: String,
    endBasic: String,
    tabindex: Number,
    label: String,
    disabled: Boolean,
    placeholder: String,
    // 勤務表が、この行の休憩を「手で直した休憩」として固定しているか。
    manual: Boolean,
  },
  emits: ["update-rest", "focus", "blur"],
  computed: {
    // 勤怠を見ずに、勤務表の中の値（rest[]）をそのまま出す。
    // 手入力・打刻・取り込みは、どれも同じ rest[] へ書く。欄がその値を出すだけなら、どの入口から
    // 入れても見え方は同じになる。以前（2026-07-22〜10-03）は休日・有給・代休・欠勤の行で値を隠していて、
    // 休日に出勤した日の休憩が空に見えたまま、中の値で計算・保存されていた。
    // 時刻を持たない区分を選んだ行の休憩は、勤務表（autoTime）と取り込みが空にするので、空のまま出る。
    displayValue() {
      return /^\d{2}:\d{2}$/.test(this.rest || "") ? this.rest : "";
    },
    helpText() {
      if (!this.flg) {
        return "実際に労働から離れていた休憩時間を入力してください。";
      }
      return "定時後の休憩は設定値から自動反映されます。作業・待機・電話対応等の時間は休憩には含まれないため、実績へ修正してください。手動で修正した後は自動で上書きされません。";
    },
  },
  methods: {
    onInput(val) {
      if (this.disabled) return;
      this.$emit("update-rest", { index: this.index, value: val });
    },
    onFocus() {
      this.$emit("focus");
    },
    onBlur() {
      this.$emit("blur");
    }
  }
};
</script>

<style scoped>
.roster-time-input-frame {
  position: relative;
  width: 112px;
  min-width: 112px;
  min-height: 40px;
}

/* **中身が有っても無くても、ちょうど1行ぶんの高さ。**Roster.vue の
   .roster-time-candidate と同じ決まり（高さ・行の高さ 16px・折り返さない）。片方だけ変えると、また揃わなくなる。
   高さを決めておけば、注記の中身（無い・1行・長い）で入力欄の位置が変わらない（監査 FF-1）。
   欄より長い注記は右へはみ出す（overflow は切らない）。はみ出しはセルの右の余白に収まる長さにしておく。 */
.roster-auto-rest-note {
  display: block;
  margin-top: -2px;
  height: 16px;
  min-height: 16px;
  color: #5c6770;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
}
</style>
